// Public marketing and legal pages of revosdirector.com that paint straight away, without waiting for the
// owner bootstrap check (GET /api/auth/check-bootstrap) that guards the Panel. A fresh install that still
// needs its owner account is redirected to /bootstrap as soon as that check answers, so nothing is lost;
// in production the check never redirects and the visitor just stops waiting for it. The list mirrors
// frontend/public/sitemap.xml (publicPaths.test.js fails if a sitemap page is missing) plus the two
// recommended-tools pages that the sitemap leaves out.

const PUBLIC_PATHS = new Set([
  "/services", "/es/servicios",
  "/get-help", "/es/pedir-ayuda",
  "/workflow-audit", "/es/auditoria-ia", "/workflow-audit/tools", "/es/auditoria-ia/recursos",
  "/ai-readiness-scorecard", "/es/evaluacion-preparacion-ia",
  "/website-security-check", "/es/verificacion-seguridad-web",
  "/website-launch-check", "/es/verificacion-lanzamiento-web",
  "/landing-pages-and-agents", "/es/landing-pages-agentes-ia",
  "/instant-report", "/es/informe-instantaneo", "/instant-report/sample", "/es/informe-instantaneo/ejemplo",
  "/automate-small-business-admin", "/es/automatizar-tareas-administrativas",
  "/automate-enquiries-and-quotes", "/es/automatizar-consultas-y-presupuestos",
  "/ai-assistant-for-customer-enquiries", "/es/asistente-ia-para-consultas-de-clientes",
  "/landing-page-for-small-business", "/es/landing-page-para-pequenas-empresas",
  "/ai-for-accountants", "/es/ia-para-asesorias",
  "/ai-for-property-managers", "/es/ia-para-gestion-inmobiliaria",
  "/ai-for-logistics-firms", "/es/ia-para-empresas-de-logistica",
  "/ai-for-recruitment-agencies", "/es/ia-para-agencias-de-seleccion",
  "/privacy-policy", "/es/politica-privacidad",
  "/cookie-policy", "/es/politica-cookies",
  "/terms-of-service", "/es/terminos-de-servicio",
]);

export function isPublicFirstPaintPath(pathname) {
  const clean = String(pathname || "").split(/[?#]/)[0];
  const trimmed = clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
  return PUBLIC_PATHS.has(trimmed);
}
